<template>
  <div class="page"> 
    <div>
      <b-tabs content-class="mt-3">
        <b-tab title="Assets" active>
          <div class="top">
            <div>
              <!-- Create new asset -->
              <div class="form">
                <form class="form-inline" v-on:submit.prevent="createAsset()">
                  <select v-model="type">
                    <option value="host">Host</option>
                    <option value="domain">Domain</option>
                    <option value="iprange">IP range</option>
                    <option value="application">Application</option>
                  </select>
                  <input v-model="value" size="50" placeholder="Asset value"/>
                  <button type="submit">Create new</button>
                </form>          
              </div>
            </div>
          </div>
    
          <div class="assets">
            <div class="top">
              <div>
                Sort:
                <select v-model="assetsFilter.sortAttr">
                  <option value="type">Type</option>
                  <option value="state">State</option>
                </select>
                <input type="checkbox" id="filterCheckbox" v-model="assetsFilter.sortReverse">
                <label for="filterCheckbox">reverse</label>
              </div>
              <div>
                Filter by Type:
                <select v-model="filterType" @change="refreshAssets">
                  <option value="">All</option>
                  <option value="host">Host</option>
                  <option value="domain">Domain</option>
                  <option value="application">Application</option>         
                </select>
                State:
                <select v-model="state" @change="refreshAssets">
                  <option value="">All</option>
                  <option value="suggested">Suggested</option>
                  <option value="confirmed">Confirmed</option>
                  <option value="rejected">Rejected</option>         
                </select>
                Level:
                <select v-model="level" @change="refreshAssets">
                  <option value="">All</option>
                  <option value="monitoring">Monitoring</option>
                  <option value="continuous_testing">Continuous Testing</option>
                  <option value="penetration">Penetration</option>         
                </select>
                <input type="checkbox" id="ManualCheckbox" v-model="manuallyAdded" @change="refreshAssets">
                <label for="ManualCheckbox">Manually added</label>
                <!--<input v-model="assetsFilter.value" size="25" placeholder="Value"/>-->
              </div>
              <div>
                <!--<span v-show="updateProgress < 100">Updating {{updateProgress}}% </span>-->
                <button @click="refreshAssets">Refresh</button>
                <div>Assets {{filteredAssets.length}} of {{assetsTotal}}</div>
              </div>
            </div>
            <Asset v-for="asset in filteredAssets" :key="asset.id" :asset="asset"/>
            <div>
              <button v-show="this.assetsPage - 1" @click="prevPage">Prev</button>
              Page {{this.assetsPage}} of {{this.assetsPages }}
              <button v-show="this.assetsPage-this.assetsPages" @click="nextPage">Next</button>
            </div>
          </div>

          <!--<div class="assets">
            <b>Assets</b>
            <div class="top">
              <div>
                <button id="refreshAssetsBtn" @click="refreshAssets">Refresh</button>
              </div>
            </div>
            <Asset v-for="asset in assets" :key="asset.id" :asset="asset"/>
          </div> -->
  
        </b-tab>
        <b-tab title="Activity Logs">
          <div>
            <button @click="refreshActivities">Refresh</button>
          </div>
          <div class="activities">
            <Activity v-for="activity in activities" :key="activity.id" :activity="activity"/>
          </div>
        </b-tab>
      </b-tabs>
    </div> 
  </div>
    


</template>

<style>
</style>

<script>
import { mapState } from 'vuex'
import Asset from '@/components/Asset.vue'
import Activity from '@/components/Activity.vue'

export default {
  name: 'assets',
  components: {
    Asset,
    Activity
  },
  computed: { 
    filteredAssets() {
      // console.log('filteredAssets:', this.assets)
      if (!this.assets || !this.assets.length) return []
      var assets = this.assets
      // Sort keywords
      var sortAttr = this.assetsFilter.sortAttr
      var sortReverse = this.assetsFilter.sortReverse
      assets.sort(function(a, b) {
        // Strings
        if (typeof a[sortAttr] === 'string'){
          if (sortReverse)
            return b[sortAttr].toLowerCase().localeCompare(a[sortAttr].toLowerCase())
          return a[sortAttr].toLowerCase().localeCompare(b[sortAttr].toLowerCase())
        }
        // Other
        if (sortReverse)
          return a[sortAttr] - b[sortAttr]// Ascending
        return b[sortAttr] - a[sortAttr]// Ascending
      })
      return assets
    },   
    ...mapState([
      'debugMode',
      'account',
      'profile',
      'assets',
      'assetsFilter',
      'activities',
      'assetsPage',
      'assetsPages',
      'assetsTotal'
    ])
  },
  methods: {
    refreshAssets () {
      if (!this.profile.id) return
      this.$store.dispatch('loadAssets', {
        all: 'false',
        type: this.filterType,
        state: this.state,
        level: this.level,
        manuallyAdded: this.manuallyAdded
      })
    },
    createAsset () {
      if (!this.value && !this.values) return
      // console.log('createAsset:'+this.type,this.value)
      this.$store.dispatch('createAsset', {
        type: this.type,
        value: this.value
      })
      this.refreshAssets()
    },
    refreshActivities () {
      if (!this.profile.id) return
      this.$store.dispatch('loadActivities')
      // console.log('loadAssets:',this.activities)
    },
    prevPage () {
      // console.log('Previous Page.')
      this.$store.dispatch('loadPrevAssets')
    },
    nextPage () {
      // console.log('Next Page.')
      this.$store.dispatch('loadNextAssets')
    }
  },
  watch: {
    profile () {
      this.refreshAssets()
      this.refreshActivities()
    }
  },
  mounted () {
    this.refreshAssets()
    this.refreshActivities()
  },
  data () {
    return {
      type: 'domain',
      value: '',
      state: '',
      level: '',
      manuallyAdded: '',
      filterType: ''
    }
  }
}
</script>
